import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../store/actions';
import HomeRevelutionSlider from '../../components/Home/home.revelution-slider';
import HomePopupPromotion from '../../components/Home/home.popup-promotion';
import HomeNewArraival from '../../components/Home/home.new-arrivals';
import HomeBrands from '../../components/Home/home.brands';
import _ from 'lodash';

class HomePage extends React.Component {
    componentDidMount() {
        this.handleSet();
    }

    componentDidUpdate(prevProps) {
        !_.isEqual(prevProps.currentLanguage, this.props.currentLanguage) && this.handleSet();
    }

    handleSet = () => {
        const { updateWording, getHeroSlider, getNewArrival, getPopupPromotion } = this.props;
        
        updateWording();
        getHeroSlider();
        getNewArrival();
        getPopupPromotion();
    }

    render() {
        return (
            <>
                <HomePopupPromotion />
                <HomeRevelutionSlider />
                <HomeNewArraival />
                <HomeBrands />
            </>
        );
    }
}

const mapStateToProps = ({ language }) => ({
    currentLanguage: language.currentLanguage
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            getPopupPromotion: Actions.getPopupPromotion,
            updateWording: Actions.updateWording,
            getHeroSlider: Actions.getHeroSlider,
            getNewArrival: Actions.getNewArrival
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
